<template>
    <div>
      <div class="header">
        <div class="clock">{{clock}}</div>
      </div>
      <DeparturesTable :panelConfig="panelConfig" :stopData="stopData"></DeparturesTable>
    </div>
</template>

<script>
import DeparturesTable from './DeparturesTable';

export default {
  components: {
    DeparturesTable
  },
  props: ['panelConfig', 'stopData', 'clock'],
};
</script>

<style>
body {
  background-color: #ddd;
}
</style>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: center;
  background-color: #ddd;
}
::v-deep {
  table {
    tr:nth-child(even) {
      background: #eaeaea;
    }
    tr:nth-child(odd) {
      background: #ddd;
    }
  }
}
@media only screen and (min-width: 600px) {
  .clock {
    font-size: 5.7em;
    font-weight: 600;
    line-height: 1em;
  }
}
</style>